/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdApplicationStoreYandexGamesYandexBonusResultDataFromJSON, FxIdApplicationStoreYandexGamesYandexBonusResultDataToJSON, } from './FxIdApplicationStoreYandexGamesYandexBonusResultData';
/**
 * Check if a given object implements the FxIdApplicationStoreYandexGamesRedeemYandexBonusResult interface.
 */
export function instanceOfFxIdApplicationStoreYandexGamesRedeemYandexBonusResult(value) {
    if (!('Records' in value) || value['Records'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationStoreYandexGamesRedeemYandexBonusResultFromJSON(json) {
    return FxIdApplicationStoreYandexGamesRedeemYandexBonusResultFromJSONTyped(json, false);
}
export function FxIdApplicationStoreYandexGamesRedeemYandexBonusResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Records': (json['Records'].map(FxIdApplicationStoreYandexGamesYandexBonusResultDataFromJSON)),
    };
}
export function FxIdApplicationStoreYandexGamesRedeemYandexBonusResultToJSON(json) {
    return FxIdApplicationStoreYandexGamesRedeemYandexBonusResultToJSONTyped(json, false);
}
export function FxIdApplicationStoreYandexGamesRedeemYandexBonusResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Records': (value['Records'].map(FxIdApplicationStoreYandexGamesYandexBonusResultDataToJSON)),
    };
}
//# sourceMappingURL=FxIdApplicationStoreYandexGamesRedeemYandexBonusResult.js.map